import AccountPicker from '../AccountPicker';

// Thin wrapper around AccountPicker that speaks account_number (string)
// instead of full account objects. Use this anywhere the consumer just
// needs the identifier (formula tokens, weight fields, persisted refs).
// For callers that need the full account record (e.g. FavoriteAccount),
// use AccountPicker directly.
const AccountPickerByNumber = ({ value, onChange, ...rest }) => (
    <AccountPicker
        {...rest}
        value={value}
        onChange={(account) => onChange(account?.account_number)}
    />
);

export default AccountPickerByNumber;